import React from 'react';

interface DateInputProps {
  value: string; // ISO format string (YYYY-MM-DD)
  onChange: (isoDate: string) => void;
  label?: string;
}

export function DateInput({
  value,
  onChange,
  label,
}: DateInputProps) {
  // Calculate date constraints for 18+ age requirement
  const today = new Date();
  const minDate = new Date(today.getFullYear() - 100, today.getMonth(), today.getDate());
  const maxDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());

  const minDateStr = minDate.toISOString().split('T')[0];
  const maxDateStr = maxDate.toISOString().split('T')[0];

  return (
    <div>
      {label && (
        <label className="mb-1 block text-sm font-medium text-on-surface-variant">{label}</label>
      )}
      <input
        type="date"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        min={minDateStr}
        max={maxDateStr}
        className="w-full rounded-lg border border-outline bg-surface px-3 py-2"
      />
    </div>
  );
}
